import AuthLayout from "./AuthLayout";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import OTPInput from "react-otp-input";
import { useState } from "react";

const OtpVerification = () => {
  const navigate = useNavigate();
  const [otp, setOtp] = useState<string>("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (otp.length === 4) {
      navigate("/reset-password");
    } else {
      alert("Please enter a valid 4-digit OTP");
    }
  };

  return (
    <AuthLayout>
      <div className="authBox">
        <h2>Verify Email Address</h2>
        <p>
          A verification OTP has been sent to your email. Please check your
          inbox.
        </p>
        <form className="form" onSubmit={handleSubmit}>
          <div className="control_group">
            <label htmlFor="otp">Enter OTP</label>
            <div className="opt_fields">
              <OTPInput
                value={otp}
                onChange={setOtp}
                numInputs={4}
                renderInput={(props) => <input {...props} id="otp" />}
                inputType="tel"
                shouldAutoFocus
              />
            </div>
            <div className="auth_bottom">
              <p>
                <button className="link" onClick={() => navigate("/")}>
                  Resend OTP (30s)
                </button>
              </p>
            </div>
          </div>
          <div className="form_btn">
            <Button
              type="submit"
              className="btn btn_primary w_100"
            >
              Submit
            </Button>
          </div>
        </form>
        <div className="auth_bottom">
          <p>
            <button className="link" onClick={() => navigate("/")}>
              <KeyboardBackspaceIcon /> Back to Login
            </button>
          </p>
        </div>
      </div>
    </AuthLayout>
  );
};

export default OtpVerification;
